// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2yZZS","link":"Footer_link__aoqay"};